// 马其顿语
const mk = {
  common: {
    notSupport: 'Вашиот прелистувач не поддржува целосен екран',
    loadFail: 'Неуспешно вчитување на темата',
    noPermission: 'Жалиме, немате дозвола за пристап до таа страница',
    backHome: 'Вратете се на почетната страница',
    noExit: 'Страницата што се обидувате да ја пристапите не постои',
    serverError: 'Жалиме, серверот наиде на грешка',
    slide: 'Повлечете надесно',
    veryHigh: 'Многу високо',
    high: 'Високо',
    target: 'Цел',
    urgentLow: 'Многу ниско',
    agpNoData: 'AGP извештајот бара најмалку 5 дена податоци за да се генерира',
    noDataStr: 'Нема податоци',
    setting: 'Поставки',
    personInfo: 'Основни информации',
    updatePwd: 'Промени лозинка',
    upHead: 'Постави слики',
    inRange: 'Во опсег',
    normal: 'Нормално',
    low: 'Ниско',
    previous: 'Претходно',
    next: 'Следно',
    search: 'Барај',
    reset: 'Ресетирај',
    cancel: 'Откажи',
    ok: 'Ок',
    confirm: 'Потврди',
    save: 'Зачувај',
    submit: 'Поднеси',
    successful: 'Успешно',
    pleaseEnter: 'Ве молиме внесете',
    pleaseSelect: 'Ве молиме изберете',
    success: 'Успех',
    confirmLogout: 'Дали сте сигурни дека сакате да се одјавите?',
    updateSuccessed: 'Ажурирањето беше успешно',
    warning: 'Предупредување',
    date: 'Датум',
    start: 'Почеток',
    end: 'Крај',
    sevenDays: '7 дена',
    fourteenDays: '14 дена',
    thirtyDays: '30 дена',
    signOut: 'Одјави се',
    personalInformation: 'Лични информации',
    email: 'Е-пошта',
    name: 'Име',
    mobile: 'Мобилен',
    dateOfBirth: 'Датум на раѓање',
    gender: 'Пол',
    diabeteType: 'Тип на дијабетес',
    dateOfDignose: 'Година на дијагноза',
    remarks: 'Забелешки',
    optionMale: 'Машки',
    optionFemale: 'Женски',
    optionUnknow: 'Претпочитам да не кажам',
    noDiabetes: 'Без дијабетес',
    diabeteTypeI: 'Тип I',
    diabeteTypeII: 'Тип II',
    diabeteSpecial: 'Посебен',
    diabeteGestational: 'Гестациски дијабетес',
    diabeteOthers: 'Друго',
    ruleMsgEmail: 'Ве молиме внесете е-пошта',
    ruleMsgName: 'Ве молиме внесете име',
    ruleMsgMobile: 'Ве молиме внесете мобилен',
    ruleMsgBirthday: 'Ве молиме изберете датум на раѓање',
    ruleMsgSex: 'Ве молиме изберете пол',
    ruleMsgDiabeteType: 'Ве молиме изберете тип на дијабетес',
    ruleMsgDateOfDignose: 'Ве молиме изберете година на дијагноза',
    ruleMsgRemarks: 'Ве молиме внесете забелешки',
    ruleMsgCorrectMobile: 'Ве молиме внесете точен мобилен број',
    oldPassword: 'Стара лозинка',
    newPassword: 'Нова лозинка',
    confirmPassword: 'Потврди лозинка',
    ruleMsgOldPassword: 'Ве молиме внесете стара лозинка',
    ruleMsgNewPassword: 'Ве молиме внесете нова лозинка',
    ruleMsgConfirmPassword: 'Ве молиме потврдете ја лозинката',
    passwordInconsistent: 'Двете внесени лозинки не се совпаѓаат',
    passwordModifySuccessed:
      'Вашата лозинка е ресетирана, ве молиме најавете се повторно!',
    monday: 'Пон',
    tuesday: 'Вто',
    wednesday: 'Сре',
    thursday: 'Чет',
    friday: 'Пет',
    saturday: 'Саб',
    sunday: 'Нед',
    sn: 'Сериски број (SN)',
    startDate: 'Датум на почеток',
    days: 'дена',
    pdfDate: 'Цел',
    close: 'затвори',
    inputTip: 'Ве молиме внесете клучни зборови за пребарување',
    polarization: 'Инициализација на уредот',
    hour: 'час',
    minutes: 'минута',
    seconds: 'секунда',
    reportDownLoadTip: 'Вашиот извештај не е генериран 5 дена.',
    age: 'возраст',
    goal: 'Цел',
    expired: 'сензорот е истечен',
    lastTime: 'Последно освежено време',
    timeZone: 'Временска зона'
  },
  route: {
    login: 'Најава',
    forget: 'Ја заборавив лозинката',
    home: 'Дома',
    glucoseReport: 'Извештај за глукоза',
    sessionReport: 'Извештај за сесија',
    eventList: 'Листа на настани',
    followerList: 'Листа на следбеници',
    followerListQ: 'Барање за набљудувач',
    settings: 'Поставки',
    profile: 'Профил'
  },
  login: {
    rememberMe: 'Запомни ја мојата најава',
    forgetPassword: 'Ја заборавив лозинката',
    agree: 'Најавата значи дека се согласувате со FurCarer',
    privacyPolicy: 'Политика за приватност',
    CGMUser: 'CGM корисник',
    follower: 'Следбеник',
    ruleMsgPassword: 'Ве молиме внесете лозинка',
    login: 'Најава',
    phonePlacehold: 'Ве молиме внесете телефонски број',
    codePlacehold: 'Ве молиме внесете код за потврда',
    phoneTip: 'Преку телефон',
    emialTip: 'Преку е-пошта',
    codeTip: 'Добијте код за верификација',
    reGetTip: 'Повторно добивање'
  },
  layout: {
    collapseUp: 'Скриј мени',
    collapseDown: 'Прошири мени',
    refresh: 'Освежи',
    backHome: 'Дома',
    helpCenter: 'Центар за помош',
    fullScreen: 'Цел екран'
  },
  forget: {
    ruleMsgCode: 'Ве молиме внесете код',
    sendCode: 'Испрати код',
    tipsMsgSendSuccess: 'Кодот за потврда е успешно испратен!',
    tipsMsgModifySuccess: 'Успешна промена на лозинка'
  },
  home: {
    todaysGlucose: 'Глукоза денес',
    todaysOverview: 'Преглед денес',
    maxGlucose: 'Макс. глукоза',
    minGlucose: 'Мин. глукоза',
    avgGlucose: 'Просечна глукоза',
    maxmumVariation: 'Максимална варијација',
    glucose: 'Глукоза',
    tir: 'TIR',
    latestGlucose: 'Најнова глукоза',
    todayPercentage: '% од денес во различни опсези',
    fourHour: '4 часа',
    eightHour: '8 часа',
    twelveHour: '12 часа',
    twentyFourHour: '24 часа',
    glucoseOnly: 'Само глукоза',
    sessionOverview: 'Преглед на сесијата',
    glocuseMetrics: 'Метрики за глукоза',
    agp: 'AGP',
    dailyGlucose: 'Дневна глукоза',
    sessionGlucose: 'Глукоза од сесија',
    standTir: 'Стандарден TIR',
    customTir: 'Прилагоден TIR',
    cancleGz: 'Отследи',
    cancleText: 'Дали сакате да го отследите тековниот корисник?',
    helpCenterTip: 'Функцијата сè уште не е достапна'
  },
  glucoseReport: {
    statics: 'Статистика',
    sixHour: 'TIR за 6 часа',
    avgGlucose: 'Просечна глукоза',
    maxGlucose: 'Макс. глукоза',
    minGlucose: 'Мин. глукоза',
    cv: 'CV',
    high: 'Број на високи',
    low: 'Број на ниски',
    normal: 'Број на нормални',
    tir: 'TIR',
    estimatedA1c: 'Проценета A1c',
    min: 'Мин',
    avg: 'Просек',
    max: 'Макс',
    maxVariation: 'Макс варијација'
  },
  glucoseProfile: {
    avg: 'Просек',
    sd: 'SD',
    cv: 'CV'
  },
  eventList: {
    all: 'Сите',
    bg: 'BG',
    meal: 'Оброк',
    sport: 'Спорт',
    insulin: 'Инсулин',
    alert: 'Аларм',
    eventType: 'Тип на настан',
    description: 'Опис',
    note: 'Белешка',
    highAlert: 'аларм предупредување',
    calibration: 'Калибрација',
    meds: 'Лекови',
    time: 'Време',
    detail: 'Детали',
    weigt: 'Тежина'
  },
  followerList: {
    title: 'Корисници за следење',
    tabTitle: 'Управување со следбеници',
    refreshText:
      'Автоматско освежување (листата на корисници автоматски се освежува на секои 30 секунди)',
    addText: 'Додај',
    dataText: 'Податоците се добиени',
    timeText: 'минути',
    hourText: 'часови',
    agoText: 'пред',
    tableEmail: 'Внесете број на сметка',
    searchPlacehold: 'Ве молиме внесете го бројот на сметка за пребарување',
    pending: 'Во тек',
    approved: 'Одобрено',
    rejected: 'Одбиено',
    addFollower: 'Додај следбеник',
    editFollower: 'Уреди следбеник',
    tableName: 'Име',
    tableAddTime: 'Време на додавање',
    tableStatus: 'Статус',
    tableApproved: 'Одобрено',
    tableReject: 'Одбиј',
    tableStartSharing: 'Започни споделување',
    tableStopSharing: 'Запри споделување',
    op: 'Операција',
    sharing: 'Споделување',
    notSharing: 'Несподелување',
    tableRemove: 'отстрани',
    note: 'Белешка',
    message: 'Порака',
    ruleMsgEmailEmpty: 'Ве молиме внесете е-пошта за пребарување',
    ruleMsgNote: 'Ве молиме внесете белешка',
    ruleMsgMessage: 'Ве молиме оставете порака',
    ruleMsgEmailCorrect: 'Ве молиме внесете точна е-пошта',
    formAcknowledge:
      'Јас признавам дека додавањето следбеник ќе му овозможи на овој корисник да ги гледа моите податоци',
    sendFollowRequest: 'Испрати барање за следење',
    setNote: 'Постави белешка',
    tipsAcknowledge:
      'Ве молиме означете ја кутијата, со што признавате дека додавањето следбеник ќе му овозможи на овој корисник да ги гледа моите податоци',
    stopSharing: 'Запри споделување',
    startSharing: 'Започни споделување',
    removeUser: 'Отстрани корисник',
    confirmStopSharing:
      'Дали сте сигурни дека сакате да престанете да споделувате мерења на глукозата со овој корисник?',
    confirmStartSharing:
      'Дали сте сигурни дека сакате да започнете да споделувате мерења на глукозата со овој корисник?',
    confirmRemove:
      'Дали сте сигурни дека сакате да го отстраните овој корисник од листата?',
    approvedFollower: 'Одобрен следбеник',
    rejectFollower: 'Одбиј следбеник',
    confirmApproved:
      'Дали сте сигурни дека сакате да го одобрите ова барање за следење?',
    confirmReject:
      'Дали сте сигурни дека сакате да го одбиете ова барање за следење?',
    addTime: 'Време на додавање',
    check: 'Провери',
    remove: 'Отстрани',
    removeUserTitle:
      'Дали сте сигурни дека сакате да го отстраните овој корисник од листата?'
  },
  settings: {
    title: 'Поставки за ниво на глукоза',
    unitSet: 'Поставки за единици',
    targetSet: 'Поставки за прилагоден TIR',
    alertSet: 'Поставки за аларми',
    highAlert: 'Аларм за висока вредност',
    lowAlert: 'Аларм за ниска вредност',
    urgentLow: 'Итна ниска вредност',
    urgentHigh: 'Итна висока вредност',
    target: 'Цел'
  },
  pdf: {
    dailyStatistics: 'Дневна статистика',
    title: 'AGP извештај',
    page: 'Страница',
    generated: 'Генерирано',
    lage: 'LAGE',
    mage: 'MAGE',
    modd: 'MODD',
    range: 'Време во опсег',
    timeInRange: 'Време во опсег (TIR)',
    agpTitle: 'Амбулаторен профил на глукоза (AGP)',
    agpSubTitle:
      'AGP е резиме на вредностите на глукозата од периодот на извештајот, со медијана (50%) и други перцентили прикажани како да се случиле во еден ден',
    dailyTitle: 'Дневен профил на глукоза',
    dailySubTitle:
      'Секој дневен профил претставува период од полноќ до полноќ.',
    device: 'Уред',
    tDevice: 'Краен уред',
    print: 'Печати',
    model: 'Модел',
    deviceSn: 'Сериски број на уред',
    effectiveData: 'Ефективни податоци',
    days: 'Дена',
    appVer: 'Верзија на апликација',
    smartPhoneModel: 'Модел на паметен телефон',
    osVersion: 'Верзија на оперативен систем',
    appSetting: 'Поставки на апликација',
    GoalsforType1andType2Diabetes: 'Цели за дијабетес тип 1 и тип 2',
    Each1timeinrange15minutes: 'Секои 1% време во опсег ≈ 15 минути',
    note: 'Забелешка: Единицата % се однесува на DCCT стандардот, додека единицата mmol/mol се однесува на IFCC стандардот.'
  },
  field: {
    timeCgmActive: 'Време на активност на CGM',
    gmi: 'GMI',
    gri: 'GRI',
    eHbA1c: 'eHbA1c',
    avgPerDay: 'Просечни калибрации на ден',
    glucoseAbility: 'Варијација на глукоза',
    lage: 'Lage',
    mage: 'Mage',
    tar: 'TAR',
    tbr: 'TBR',
    calibrations: 'Број на калибрации'
  },
  agp: {
    agpTitle: 'Амбулаторен профил на глукоза (AGP)',
    centerLine: 'Медијана',
    areaLine: 'Интервал',
    target: 'Целен опсег'
  },
  basic: {
    customTir: 'Прилагоден TIR',
    bloodTip: 'Поставки за потсетници за глукоза',
    bloodUnit: 'Единица за глукоза',
    highTip: 'Аларм за висока глукоза',
    lowTip: 'Аларм за ниска глукоза',
    unitText: 'Автоматски поставено врз основа на земја/регион',
    selectTip:
      'Кликнете на иконата за да изберете или одберете го соодветниот датум',
    selectAll: 'Избери сè'
  },
  report: {
    threeMonth: 'Последни 3 месеци',
    sixMonth: 'Речиси 6 месеци',
    yearText: 'Последна година',
    showAll: 'Прикажи сè',
    all: 'Сите',
    selectDate: 'Избери опсег на датуми',
    to: 'до',
    startDt: 'Датум на почеток',
    endDt: 'Датум на крај',
    betaTest: 'Бета тестирање',
    bloodData: 'Податоци за глукоза',
    userCount: 'Корисничка сметка'
  },
  petDetail: {
    variety: 'Раса',
    type: 'Тип на инсулин',
    freq: 'Фреквенција на инсулин',
    lente: 'Ленте',
    insulin: 'Инсулин Glargine',
    pzi: 'PZI',
    nph: 'NPH',
    detemir: 'Detemir'
  },
  pdfReport: {
    title: 'AGP извештај',
    snNumber: 'Сериски број (SN)',
    page: 'Страница',
    createTime: 'Генерирано',
    petInfo: 'Информации за милениче',
    petName: 'Име на милениче',
    birthday: 'Датум на раѓање',
    freq: 'Фреквенција на инсулин',
    petType: 'Тип на милениче',
    age: 'Возраст',
    registerType: 'Тип на шприц',
    basicBloodData: 'Метрики за глукоза',
    dbText: 'Време во опсег (TIR)',
    target: 'Цели за дијабетес тип 1 и тип 2',
    recordTime: 'Време на снимање',
    tag: 'ознака',
    event: 'Настан',
    eventDetail: 'Детали за настан',
    mulityText: 'Графикон на тренд на глукоза за повеќе денови',
    mulitySubText:
      'Дневните профили на глукоза за повеќе денови го претставуваат временскиот интервал на циклус на уред',
    avageBlood: 'Просек на глукоза',
    bloodText: 'MODD',
    highTip: 'Аларм за висока глукоза',
    lowTip: 'Аларм за ниска глукоза',
    cat: 'Мачка',
    dog: 'Кучe',
    country: 'Земја',
    insulinDose: 'Доза на инсулин',
    weightUnit: 'кг'
  },
  eventDetail: {
    Empty: 'Празно',
    Breakfast: 'Појадок',
    Lunch: 'Ручек',
    Dinner: 'Вечера',
    Before_Sleep: 'Пред спиење',
    Extra: 'Екстра',
    Short_acting: 'Краткодејствувачки',
    Pre_mixed: 'Претходно измешан',
    Long_acting: 'Долгодејствувачки',
    Middle_acting: 'Среднодејствувачки',
    hour: 'h',
    minutes: 'min',
    After_Breakfast: 'Појадок',
    Before_Lunch: 'Пред ручек'
  }
};

export default mk;
